/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$image-radius: 0 !default;
$image-shadow: none !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$background-gradient: linear-gradient(rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 0%);
$background-gradient-bright: linear-gradient(rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 0%);

:host {
  display: flex;
  max-width: 100%;
  @include eon-typography();
}

:host([use-as-background=""]),
:host([use-as-background="true"]) {
  @include position-absolute();
  width: 100%;
  height: 100%;
  z-index: auto;

  .#{$prefix}image-caption-container,
  .#{$prefix}image-container {
    width: 100% !important;
    height: 100% !important;
  }
}

.#{$prefix}image-caption-container {
  position: relative;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: $image-shadow;
  border-radius: $image-radius;

  @if $image-radius != 0 {
    overflow: hidden;
  }

  .#{$prefix}image-container {
    position: relative;
    width: 100%;
    max-width: 100%;
    height: auto;
    overflow: hidden;
    display: block;

    &.#{$prefix}cover,
    &.#{$prefix}fixedRatio,
    &.#{$prefix}background {
      figure {
        width: 100%;
        height: 100%;

        picture {
          width: 100%;
          height: 100%;
          display: flex;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }

    figure {
      position: relative;
      margin: 0;
      display: inline;

      picture {
        position: relative;
        display: inline;

        img {
          width: 100%;
          max-width: 100%;
          display: block;
        }
      }
    }

    &.#{$prefix}ratio-2x1 {
      &::after {
        @include aspect-ratio(2, 1);
      }
    }

    &.#{$prefix}ratio-2x3 {
      &::after {
        @include aspect-ratio(2, 3);
      }
    }

    &.#{$prefix}ratio-16x9 {
      &::after {
        @include aspect-ratio(16, 9);
      }
    }

    &.#{$prefix}ratio-1x1 {
      &::after {
        @include aspect-ratio(1, 1);
      }
    }

    &.#{$prefix}ratio-3x4 {
      &::after {
        @include aspect-ratio(3, 4);
      }
    }

    &.#{$prefix}ratio-4x3 {
      &::after {
        @include aspect-ratio(4, 3);
      }
    }

    &.#{$prefix}ratio-3x1 {
      &::after {
        @include aspect-ratio(3, 1);
      }
    }

    &.#{$prefix}placeholder {
      &::after {
        content: "";
        padding-top: calc((var(--placeholderDimensionHeight) / var(--placeholderDimensionWidth)) * 100%);
        display: block;
      }
    }

    &.#{$prefix}ratio-2x1,
    &.#{$prefix}ratio-2x3,
    &.#{$prefix}ratio-16x9,
    &.#{$prefix}ratio-1x1,
    &.#{$prefix}ratio-3x4,
    &.#{$prefix}ratio-4x3,
    &.#{$prefix}ratio-3x1,
    &.#{$prefix}placeholder {
      figure {
        @include position-absolute();
      }
    }

    .#{$prefix}image-shadow-overlay {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: $background-gradient;
    }

    .#{$prefix}image-shadow-overlay-bright {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: $background-gradient-bright;
    }

    .#{$prefix}image-violator {
      position: absolute;

      @mixin setMargin($margin) {
        &.#{$prefix}v-top {
          top: $margin;
        }

        &.#{$prefix}v-bottom {
          bottom: $margin;
        }

        &.#{$prefix}v-center {
          top: 50%;
          transform: translateY(-50%);
        }

        &.#{$prefix}left {
          left: $margin;
        }

        &.#{$prefix}center {
          left: 50%;
          transform: translateX(-50%);
        }

        &.#{$prefix}center {
          &.#{$prefix}v-center {
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        &.#{$prefix}right {
          right: $margin;
        }
      }

      @include for-size(desktop-l-or-larger) {
        @include setMargin(32px);
      }

      @include for-size(desktop) {
        @include setMargin(24px);
      }

      @include for-size(tablet-or-smaller) {
        @include setMargin(16px);
      }
    }
  }
}

::slotted(eon-ui-violator) {
  display: block;
}
